import type { Table, Column } from "@tanstack/vue-table";
import { Ref, computed } from "vue";

export const useColumnVisibility = <T>(
  table: Table<T>,
  columnVisibility: Ref,
) => {
  const columnsToggleList = computed(() => {
    return table.getAllLeafColumns().filter((column) => column.getCanHide());
  });

  const toggleColumnVisibility = <U>(column: Column<U>) => {
    columnVisibility.value = {
      ...columnVisibility.value,
      [column.id]: !column.getIsVisible(),
    };
  };

  return { columnsToggleList, toggleColumnVisibility };
};
